import { createContext, useContext } from 'react'
import CommonStore from './commonStore'
import UserStore from './userStore'
import BidsStore from './bidsStore'
import AuctionStore from './auctionStore'
import PostStore from './postStore'
import PaymentStore from './paymentStore'
import MyActivityStore from './myActivityStore'
import FavoriteAuctionsStore from './favoriteAuctionsStore'
import NavigationStore from './navigationStore'
import AuctionListStore from './auctionListStore'
import MethodsStore from './methodsStore'
import PostListStore from './postListStore'
import AuctionDetailsStore from './auctionDetailsStore'
import ProfileStore from './profileStore'
import PackageStore from './packageStore'
import LogsStore from './logsStore'
import HomeFilterStore from './homeFilterStore'
import ExchangeCurrencyStore from './exchangeCurrencyStore'
import NotificationsStore from './notificationsStore'

interface Store {
  commonStore: CommonStore
  bidsStore: BidsStore
  userStore: UserStore
  auctionStore: AuctionStore
  postStore: PostStore
  paymentStore: PaymentStore
  activityStore: MyActivityStore
  favoriteAuctionsStore: FavoriteAuctionsStore
  navigationStore: NavigationStore
  auctionListStore: AuctionListStore
  postListStore: PostListStore
  methodsStore: MethodsStore
  auctionDetailsStore: AuctionDetailsStore
  profileStore: ProfileStore
  packageStore: PackageStore
  logsStore: LogsStore
  homeFilterStore: HomeFilterStore
  exchangeCurrencyStore: ExchangeCurrencyStore
  notificationsStore: NotificationsStore
}

export const store: Store = {
  commonStore: new CommonStore(),
  bidsStore: new BidsStore(),
  userStore: new UserStore(),
  auctionStore: new AuctionStore(),
  postStore: new PostStore(),
  paymentStore: new PaymentStore(),
  activityStore: new MyActivityStore(),
  favoriteAuctionsStore: new FavoriteAuctionsStore(),
  navigationStore: new NavigationStore(),
  auctionListStore: new AuctionListStore(),
  postListStore: new PostListStore(),
  methodsStore: new MethodsStore(),
  auctionDetailsStore: new AuctionDetailsStore(),
  profileStore: new ProfileStore(),
  packageStore: new PackageStore(),
  logsStore: new LogsStore(),
  homeFilterStore: new HomeFilterStore(),
  exchangeCurrencyStore: new ExchangeCurrencyStore(),
  notificationsStore: new NotificationsStore(),
}

export const StoreContext = createContext(store)

export function useStore() {
  return useContext(StoreContext)
}
